import React, { Component } from 'react'
import { isEmpty } from "lodash"
import { Alert } from 'reactstrap';

class EmptyPage extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        let { msg } = this.props
        if (isEmpty(msg))
            msg = "No record found.";
        return (
            <div>
                <Alert color="info" className="mb-0" role="alert">
                    <h5 className="font-size-16 me-3">{msg}</h5>
                </Alert>
            </div>
        )
    }
}

export default EmptyPage;